import { Typography } from 'antd';

const EnvMessage = () => process.env?.REACT_APP_NODE_ENV !== 'production' ? <Typography.Text type="danger" strong>{(process.env?.REACT_APP_NODE_ENV || 'development').toUpperCase()} ENV</Typography.Text> : null;

export default EnvMessage;
